module.exports = __webpack_public_path__ + "components/t-shirt-comp/static/Zarautz-1bccca205cf4446b91872a9059ac0e63.jpg";